import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import { JsonAttributeOperator } from '../conditions/json-attributes';

export const OPERATOR_MAP = [
  {
    segment: 'eq',
    attribute: '=',
    event_attribute: '=',
    event: '==',
  },
  {
    segment: '!eq',
    attribute: '!=',
    event_attribute: '!=',
    event: '!==',
  },
  {
    segment: 'exists',
    attribute: 'exists',
    event_attribute: 'exists',
    event: 'exists',
  },
  {
    segment: '!exists',
    attribute: '!exists',
    event_attribute: '!exists',
    event: '!exists',
  },
  {
    segment: 'gt',
    event: '>',
    attribute: '>',
    event_attribute: '>',
  },
  {
    segment: 'lt',
    event: '<',
    attribute: '<',
    event_attribute: '<',
  },
  {
    segment: 'contains',
    event: '=~',
    attribute: 'contains',
    event_attribute: 'contains',
  },
  {
    segment: '!contains',
    event: '!=~',
    attribute: '!contains',
    event_attribute: '!contains',
  },
  {
    segment: 'timestamp',
    event: 'timestamp',
    attribute: 'timestamp',
    event_attribute: 'timestamp',
  },
  {
    segment: '!timestamp',
    event: '!timestamp',
    attribute: '!timestamp',
    event_attribute: '!timestamp',
  },
  {
    segment: 'timestamp_gt',
    event: 'timestamp_greater',
    attribute: 'timestamp_gt',
    event_attribute: 'timestamp_gt',
  },
  {
    segment: 'timestamp_lt',
    event: 'timestamp_less',
    attribute: 'timestamp_lt',
    event_attribute: 'timestamp_lt',
  },
  {
    segment: 'timestamp_gta',
    event: 'timestamp_gta',
    attribute: 'timestamp_gta',
    event_attribute: 'timestamp_gta',
  },
  {
    segment: 'timestamp_lta',
    event: 'timestamp_lta',
    attribute: 'timestamp_lta',
    event_attribute: 'timestamp_lta',
  },
  {
    segment: 'bw',
    event: 'bw',
    attribute: 'bw',
    event_attribute: 'bw',
  },
  {
    segment: 'timestamp_bw',
    event: 'timestamp_bw',
    attribute: 'timestamp_bw',
    event_attribute: 'timestamp_bw',
  },
  {
    segment: 'email_valid',
    event: 'email_valid',
    attribute: 'email_valid',
    event_attribute: 'email_valid',
  },
  {
    segment: '!email_valid',
    event: '!email_valid',
    attribute: '!email_valid',
    event_attribute: '!email_valid',
  },
  {
    segment: 'contained_in_array',
    event: 'contained_in_array',
    attribute: 'contained_in_array',
    event_attribute: 'contained_in_array',
  },
  {
    segment: '!contained_in_array',
    event: '!contained_in_array',
    attribute: '!contained_in_array',
    event_attribute: '!contained_in_array',
  },
  {
    segment: JsonAttributeOperator.ArrayHasPropertyOrValue,
    event: JsonAttributeOperator.ArrayHasPropertyOrValue,
    attribute: JsonAttributeOperator.ArrayHasPropertyOrValue,
    event_attribute: JsonAttributeOperator.ArrayHasPropertyOrValue,
  },
  {
    segment: JsonAttributeOperator.ArrayOrObjectHasPropertyOrValue,
    event: JsonAttributeOperator.ArrayOrObjectHasPropertyOrValue,
    attribute: JsonAttributeOperator.ArrayOrObjectHasPropertyOrValue,
    event_attribute: JsonAttributeOperator.ArrayOrObjectHasPropertyOrValue,
  },
  {
    segment: JsonAttributeOperator.ArrayIndexHasPropertyOrValue,
    event: JsonAttributeOperator.ArrayIndexHasPropertyOrValue,
    attribute: JsonAttributeOperator.ArrayIndexHasPropertyOrValue,
    event_attribute: JsonAttributeOperator.ArrayIndexHasPropertyOrValue,
  },
  {
    segment: JsonAttributeOperator.ObjectHasProperty,
    event: JsonAttributeOperator.ObjectHasProperty,
    attribute: JsonAttributeOperator.ObjectHasProperty,
    event_attribute: JsonAttributeOperator.ObjectHasProperty,
  },
];

function values(object) {
  return Object.keys(object).map((key) => object[key]);
}

function findMap(operator) {
  return OPERATOR_MAP.find((map) => values(map).includes(operator));
}

export default function (operator, { to = 'segment' } = {}) {
  let map = findMap(operator);

  assert(`couldn't convert operator "${operator}" to "${to}"`, !isNone(map));

  return map[to];
}
